import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ProfileOutlinedSvg from "@ant-design/icons-svg/es/asn/ProfileOutlined";
import AntdIcon from '../components/AntdIcon';
var ProfileOutlined = function ProfileOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: ProfileOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ProfileOutlined.displayName = 'ProfileOutlined';
}
export default /*#__PURE__*/React.forwardRef(ProfileOutlined);